export async function loadSquareShape(engine, refresh = true) {
    const { SquareDrawer } = await import("./SquareDrawer.js");
    await engine.addShape(["edge", "square"], new SquareDrawer(), refresh);
}
